import type { PublicSiteIntegrationFlags } from "@Front/Services/PublicSiteConfig/publicSiteConfigLoader";

export type StepEmailProAuthUiFlags = {
	showIdNotNotaryBlock: boolean;
};

/**
 * Connexion professionnelle : IdNot uniquement (OAuth DocV retiré du produit).
 */
export function computeStepEmailProAuthUiFlags(params: {
	ready: boolean;
	flags: PublicSiteIntegrationFlags;
	login_show_idnot_notary_connection: boolean;
}): StepEmailProAuthUiFlags {
	const { ready, flags, login_show_idnot_notary_connection } = params;
	const showIdNotNotaryBlock = ready && flags.uses_idnot && login_show_idnot_notary_connection;
	return { showIdNotNotaryBlock };
}
